import { render, staticRenderFns } from "./PlayerRegistrationClosePage.vue?vue&type=template&id=a67b7976&scoped=true&"
import script from "./PlayerRegistrationClosePage.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationClosePage.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegistrationClosePage.vue?vue&type=style&index=0&id=a67b7976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b7976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
